module.exports = __webpack_public_path__ + "static/media/noteTaker.b9681f6b.png";